/**
 * Coupon codes → reward tiles in YOUR REWARDS (persisted on users.{uid}.rewardsToRedeem).
 * Match is case-insensitive; codes are normalized to uppercase before lookup.
 */
const COUPON_REWARD_50_FOR_YOUR_DINNER_DATE = Object.freeze({
  title: '$50 for your dinner date',
  description: 'credit added from your coupon',
});

const COUPON_REWARD_100_FOR_YOUR_DINNER_DATE = Object.freeze({
  title: '$100 for your dinner date',
  description: 'credit added from your coupon',
});

export const COUPON_REWARD_BY_CODE = Object.freeze({
  ABDCGD: {
    title: '$50 dinner date',
    description: 'credit added from your coupon',
  },
  ADSFDS: {
    title: '$10 dinner date',
    description: 'credit added from your coupon',
  },
  BRKFTZ: COUPON_REWARD_50_FOR_YOUR_DINNER_DATE,
  BPKFTZ: COUPON_REWARD_50_FOR_YOUR_DINNER_DATE,
  BZKFTZ: COUPON_REWARD_50_FOR_YOUR_DINNER_DATE,
  BAKFTZ: COUPON_REWARD_50_FOR_YOUR_DINNER_DATE,
  BPOFTZ: COUPON_REWARD_50_FOR_YOUR_DINNER_DATE,
  BPOFLL: COUPON_REWARD_50_FOR_YOUR_DINNER_DATE,
  BPOFLP: COUPON_REWARD_50_FOR_YOUR_DINNER_DATE,
  BPOFLZ: COUPON_REWARD_100_FOR_YOUR_DINNER_DATE,
  BPOFMZ: COUPON_REWARD_100_FOR_YOUR_DINNER_DATE,
  BPOFOZ: COUPON_REWARD_100_FOR_YOUR_DINNER_DATE,
});

export function normalizeCouponCode(raw) {
  return String(raw ?? '').trim().toUpperCase();
}

/** @returns {{ code: string, title: string, description: string } | null} */
export function lookupCouponReward(raw) {
  const code = normalizeCouponCode(raw);
  if (!code) return null;
  const entry = COUPON_REWARD_BY_CODE[code];
  if (!entry) return null;
  return { code, title: entry.title, description: entry.description };
}
